import { useFetchQuery } from '@opengov/bnp-core';
import { progressTrackerQueryKeys } from './progressTrackerQueryKeys';
import { HorizontalLabelPosition, VerticalLabelPosition } from '../../context/ProgressTracker.Provider';

export type ProgressTrackerSetting = {
  id: string;
  entityId: number;
  status: string;
  colorCode: string;
  createdAt: string;
  updatedAt: string;
  verticalLabelPosition: VerticalLabelPosition;
  horizontalLabelPosition: HorizontalLabelPosition;
};

export type IProgressTrackerSettingsResponse = {
  success: boolean;
  data: ProgressTrackerSetting[];
};

export function useFetchProgressTrackerSettings(entityId: number) {
  return useFetchQuery<IProgressTrackerSettingsResponse, ProgressTrackerSetting[]>({
    queryKey: progressTrackerQueryKeys.settings(entityId),
    url: `/api/stories/v1/progressTrackerSettings/${entityId}`,
    options: {
      enabled: !!entityId,
      select: (response: IProgressTrackerSettingsResponse) => response.data // Extract just the settings array
    }
  });
}
